import type { Event, EventHint } from "@sentry/react";

export const CHUNK_RELOAD_KEY = "chunk_reloaded";

const CHUNK_ERROR_PATTERNS = [
  "error loading dynamically imported module",
  "Failed to fetch dynamically imported module",
  "Importing a module script failed",
  "reading 'AppRoutes'",
] as const;

export function isChunkLoadError(message: string): boolean {
  return CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
}

export function reloadForStaleChunks(): boolean {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    return false;
  }

  sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
  const url = new URL(window.location.href);
  url.searchParams.set("_cb", Date.now().toString());
  window.location.replace(url.toString());
  return true;
}

export function clearChunkReloadFlag(): void {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
}

export function shouldDropSentryEvent(event: Event, hint?: EventHint): boolean {
  const messages: string[] = [];

  if (event.message) {
    messages.push(event.message);
  }

  for (const exception of event.exception?.values ?? []) {
    if (exception.value) {
      messages.push(exception.value);
    }
    if (exception.type) {
      messages.push(exception.type);
    }
  }

  const original = hint?.originalException;
  if (original instanceof Error) {
    messages.push(original.message);
  } else if (typeof original === "string") {
    messages.push(original);
  }

  return messages.some((message) => isChunkLoadError(message));
}
